<style lang="scss">

</style>

<template>
    <div id='page-404'>
        <h2>404 - Page not found</h2>
    </div>
</template>

<script>
export default {
    data () {
        return {
        }
    },
}
</script>
